import { useQuery } from "@tanstack/react-query";
import { loadOnboardingData } from "../../apis";

export function useOnboardingResult({
  isMobile,
  isDark,
}: {
  isMobile: boolean;
  isDark: boolean;
}) {
  const { data, error, isLoading, isFetching, refetch } = useQuery({
    queryKey: ["onBoardingResult"],
    queryFn: async () => {
      return loadOnboardingData(isMobile, isDark);
    },
  });
  return {
    data,
    error,
    isLoading: isLoading || isFetching,
    refetch,
  };
}
